








































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperation, getOperationID } from '@/api/operations'
import { getBoUrl } from '@/api/http-constants'
import { formatBigInteger } from '@/filters/numbers'
import { TicketModule } from '@/store/modules/ticket'
import Plan from '@/components/Dashboard/Plan.vue'
import Alert from '@/components/Alert.vue'

@Component({
    filters: { formatBigInteger },
    components: {
        Plan,
        Alert,
    },
})
export default class AppartmentRecap extends Vue {
    apiService = new ApiService()
    boUrl = getBoUrl()

    id: number
    opeID: number
    userOpe: any = null
    buyerData: any = null
    modules: any[] = []
    planConfirmed: boolean = false
    confirmLoading: boolean = false
    confirmError: string = null

    sizes = {
        xs: 'Mini',
        s: 'Petit',
        m: 'Intermédiaire',
        l: 'Grand',
        xl: 'Très grand',
    }

    DOC_STATUSES = {
        pending: 'En cours de vérification',
        refused: 'Refusé',
        validated: 'Validé',
    }

    PHASE_LABELS = {
        1: 'Étape 1 — Conception',
        2: 'Étape 2 — Dossier',
        3: 'Étape 3 — Prix',
        4: 'Étape 4 — Personnalisation',
    }

    get ticketData() {
        return TicketModule.ticketData
    }

    get salePrice() {
        return TicketModule.salePrice
    }

    get phaseLabel() {
        const p = TicketModule.phase || (this.userOpe && this.userOpe.phase)
        return this.PHASE_LABELS[p] || `Étape ${p}`
    }

    get phaseBadgeClass() {
        const p = TicketModule.phase || (this.userOpe && this.userOpe.phase)
        const classes = {
            1: 'badge-warning text-dark',
            2: 'badge-info text-white',
            3: 'badge-primary text-white',
            4: 'badge-success text-white',
        }
        return classes[p] || 'badge-secondary text-white'
    }

    get adminBlueprints() {
        if (!this.userOpe || !this.userOpe.blueprints) return []
        return this.userOpe.blueprints.filter((b: any) => b.isUploadedByAdmin)
    }

    get outdoorSurfaces(): number[] {
        if (!this.userOpe) return []
        const surfaces = this.userOpe.wishedOutdoorSurfaces
        if (Array.isArray(surfaces) && surfaces.length) return surfaces
        const legacy = parseInt(this.userOpe.wishedOutdoorFloor)
        return legacy > 0 ? [legacy] : []
    }

    get hasAnyFloor(): boolean {
        if (!this.userOpe || !this.userOpe.wishedFloors) return false
        const f = this.userOpe.wishedFloors
        return !!(f.ground || f.r1 || f.intermediate || f.intermediateSupp || f.top)
    }

    get hasAnyExposure(): boolean {
        if (!this.userOpe || !this.userOpe.wishedExposures) return false
        const e = this.userOpe.wishedExposures
        return !!(e.north || e.east || e.west || e.south)
    }

    docStatusLabel(status: string | null): string {
        if (!status) return 'Non transmis'
        return this.DOC_STATUSES[status] || status
    }

    docStatusClass(status: string | null): string {
        if (status === 'validated') return 'text-success'
        if (status === 'refused') return 'text-danger'
        if (status === 'pending') return 'text-warning'
        return 'text-muted'
    }

    docStatusIcon(status: string | null): string {
        if (status === 'validated') return 'fa fa-check-circle'
        if (status === 'refused') return 'fa fa-times-circle'
        if (status === 'pending') return 'fa fa-clock-o'
        return 'fa fa-circle-o'
    }

    async created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.id = UserModule.userInfos.id
        this.opeID = await getOperationID()

        const [respOpe, respModule, buyerResp] = await Promise.all([
            this.apiService.getUserOperation(this.id, this.opeID),
            this.apiService.getModules(),
            this.apiService.getBuyer(this.id),
        ])
        this.userOpe = respOpe.data
        this.modules = respModule.data
        this.buyerData = buyerResp.data

        this.planConfirmed = this.userOpe && this.userOpe.planValidated === true

        // Charge les données de prix en parallèle (non bloquant)
        TicketModule.refresh().catch(() => { /* silent */ })
    }

    showConfirmModal() {
        const $modal = $(this.$refs.confirmModal) as any
        $modal.modal('show')
    }

    closeConfirmModal() {
        const $modal = $(this.$refs.confirmModal) as any
        $modal.modal('hide')
    }

    async confirmCandidature() {
        this.confirmLoading = true
        this.confirmError = null
        try {
            await this.apiService.postValidatePlan(this.id, this.opeID)
            this.planConfirmed = true
            this.closeConfirmModal()
            this.handleAlert('success', 'Votre candidature a bien été confirmée. L\'équipe a été notifiée et vous passez à l\'étape suivante.')
        } catch (e) {
            this.confirmError = 'Une erreur est survenue. Veuillez réessayer.'
            this.closeConfirmModal()
        } finally {
            this.confirmLoading = false
        }
    }

    showGiveUpModal() {
        const $giveUpModal = $(this.$refs.giveUpModal) as any
        $giveUpModal.modal('show')
    }

    closeGiveUpModal() {
        const $giveUpModal = $(this.$refs.giveUpModal) as any
        $giveUpModal.modal('hide')
    }

    giveUpOperation() {
        // Api call maybe
    }

    showPlanModal() {
        const $planModal = $(this.$refs.planModal) as any
        $planModal.modal('show')
    }

    closePlanModal() {
        const $planModal = $(this.$refs.planModal) as any
        $planModal.modal('hide')
    }

    handleAlert(level, msg) {
        ;(<Alert>this.$refs.alert).handleAlert(level, msg)
    }

    detachFromOpe() {
        this.apiService
            .patchDetachUserFromOperation(this.id, this.opeID)
            .then(() => {
                this.$router.push({ name: 'select-ope' })
            })
            .catch(() => {
                this.handleAlert('danger', "L'abandon du projet a échoué")
            })
    }

    get preferences() {
        if (!this.userOpe) {
            return []
        }

        const preferences = []

        // Floors
        if (this.userOpe.wishedFloors.ground) {
            preferences.push({
                img: 'logement-etage-rdc.png',
                title: 'Rez-de-chausséee',
            })
        }

        if (this.userOpe.wishedFloors.intermediate) {
            preferences.push({
                img: 'logement-etage-intermediaire.png',
                title: 'Étage intermédiaire',
            })
        }

        if (this.userOpe.wishedFloors.soho) {
            preferences.push({
                img: 'logement-soho.png',
                title: 'Duplex SOHO',
            })
        }

        if (this.userOpe.wishedFloors.top) {
            preferences.push({
                img: 'logement-etage-haut.png',
                title: 'Dernier niveau',
            })
        }

        // Exposures
        if (this.userOpe.wishedExposures.north) {
            preferences.push({
                img: 'logement-nord.png',
                title: 'Nord',
                subtitle: 'Très économique',
            })
        }

        if (this.userOpe.wishedExposures.east) {
            preferences.push({
                img: 'logement-est.png',
                title: 'Est',
                subtitle: 'Économique',
            })
        }

        if (this.userOpe.wishedExposures.west) {
            preferences.push({
                img: 'logement-ouest.png',
                title: 'Ouest',
                subtitle: 'Modéré',
            })
        }

        if (this.userOpe.wishedExposures.south) {
            preferences.push({
                img: 'logement-sud.png',
                title: 'Sud',
                subtitle: 'Plus onéreux',
            })
        }

        // Outdoor spaces
        const outdoorTotal = this.outdoorSurfaces.reduce((sum, s) => sum + s, 0)

        if (outdoorTotal > 0) {
            preferences.push({
                img: 'logement-espace-exterieur-grand.png',
                title: 'Espace extérieur',
                subtitle: `${outdoorTotal} m²`,
            })
        } else {
            preferences.push({
                img: 'logement-espace-exterieur-sans.png',
                title: "Pas d'espace extérieur",
            })
        }

        return preferences
    }
}
